<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">

import { formatShort } from '@/models/formatNumber.ts'
import { useGameStore } from '@/stores/gameStore.ts'
import { computed } from 'vue'
import { useAssetStore } from '@/stores/assetStore.ts'
import { usePlayerOreStore } from '@/stores/playerOreStore.ts'
import { CDN } from '@/models/cdn.ts'

const gameStore = useGameStore()
const assetStore = useAssetStore()
const playerOreStore = usePlayerOreStore()

const props = defineProps({
  oreId: {
    type: Number,
    required: true
  },
  top: {
    type: Number,
    required: true
  },
  left: {
    type: Number,
    required: true
  },
  debug: {
    type: Boolean,
    required: false,
    default: false
  }
})

const ore = computed(() => {
  return assetStore.findOreById(props.oreId)
})

const amount = computed(() => {
  return (playerOreStore.data as Record<string, number>)[ore.value.code]
})

const onClick = () => {
  gameStore.modalType = 'oreDetails'
  gameStore.modalData = {
    oreId: props.oreId
  }
}

</script>

<template>
  <div :class="{
    'absolute ': true,
    'border' : debug
  }" :style="'top:' + top + 'rem;left:' + left + 'rem;width:5rem;z-index:14;'">
    <div class="text-center flex-col" :style="'width:5rem;'">
      <img alt="" :class="{
            'ms-2':true,
            'opacity-50':debug
          }" style="width:4rem;" :src="CDN.ore(oreId, 64)">
      <div  class="bg-gradient-to-b from-metal-750 to-metal-900 rounded cursor-pointer" @click="onClick">
        <div>{{ ore.oreName }}</div>
        <span class="text-subtext text-lg">
          <span v-if="amount" class="text-green-500">{{ formatShort(amount) }}</span>
          <span v-else>-</span>
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>